import React from "react"
import { cn } from "~/utils"

// export function ControlButton({ className, children }: ButtonProps) {
//   return (
//     <button
//       className={cn(
//         "group inline-flex items-center justify-center whitespace-nowrap text-sm font-medium focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50",
//         "h-8 rounded-md px-1 py-6 sm:h-9 sm:px-2 sm:py-7",
//         className
//       )}
//     >
//       <span className="rounded-md p-1 ring-offset-background transition-colors group-focus-visible:outline-none group-focus-visible:ring-2 group-focus-visible:ring-white group-focus-visible:ring-offset-0">
//         {children}
//       </span>
//     </button>
//   )
// }

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ControlButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    return (
      <button
        className={cn(
          "group inline-flex items-center justify-center whitespace-nowrap text-sm font-medium focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50",
          "h-5 rounded-md px-2 py-2 sm:h-9 sm:py-7",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

ControlButton.displayName = "ControlButton"

export { ControlButton }
